export default response => {
  const ok = false;
  if (response) {
    const isFlatObject = responseObject => {
      let isFlat = [false, 'direct', 'type0'];

      const conditions = {
        ResponseStatus: [false, 'ResponseStatus', 'type1'],
        error: [true, 'error', 'type4'],
        errorResponse: [false, 'errorResponse', 'type3'],
        responseStatus: [false, 'responseStatus', 'type2'],
        verificationStatus: [true, 'verificationStatus', 'type5']
      };
      for (const key in conditions) {
        if (responseObject[key]) {
          isFlat = conditions[key];
          break;
        }
      }

      return isFlat;
    };

    //Pluck error code from response description
    const pluckErrorCode = description =>
      description
        .substring(description.search('Error') + 7, description.indexOf('.'))
        .replace(/[: \s]+/g, '');

    const genericErrorMsg =
      'Sorry, we are unable to process your request at this time. Please try again later';
    let errorCode;
    let errorMessage = genericErrorMsg;
    let errorObject;
    let httpStatus;
    let status;

    const responseArr = isFlatObject(response);
    const isFlat = responseArr[0];
    const errorVariation = responseArr[1];

    errorObject = errorVariation == 'direct' ? response : response[errorVariation];

    if (isFlat) {
      errorCode = response.verificationStatus || response.error || response.reason || 'VCO_001';
      errorMessage = response.error_description || genericErrorMsg;
      status = response.status || null;
      httpStatus = response.httpStatus;
      errorObject = response;

      if (/Error:|Error :/gi.test(response.error_description)) {
        errorCode = pluckErrorCode(response.error_description);
      }
    } else {
      //status/httpStatus/statusCode, reason/code, message
      errorObject = errorVariation == 'direct' ? response : response[errorVariation];
      errorCode = errorObject.reason || errorObject.code || 'VCO_001';
      errorMessage = errorObject.message || genericErrorMsg;
      status = errorObject.statusCode || errorObject.status || null;
      httpStatus = response.httpStatus;
    }

    return { errorCode, errorMessage, errorObject, httpStatus, ok, status };
  }
  return { ok };
};
